const conselho_etica = {
  pessoas: [
    {
      nome: 'Valdecyr Maciel Gomes',
      cargo: 'Presidente',
      descricao: 'membro independente',
      imagem: 'conselho1',
    },
    {
      nome: 'Luiz Eduardo Passos Maia',
      cargo: 'Vice-presidente',
      descricao: 'Brookfield Brasil',
      imagem: 'conselho2',
    },
    {
      nome: 'Denise Pavarina',
      cargo: 'Conselheira',
      descricao: 'membro independente',
      imagem: 'Denise-pavarina',
    },
    {
      nome: 'Luiz Augusto Candiota',
      cargo: 'Conselheiro',
      descricao: 'Lacan Investimentos e Participações',
      imagem: 'conselho4',
    },
    {
      nome: 'Marcelo Giufrida',
      cargo: 'Conselheiro',
      descricao: 'Garde',
      imagem: 'Marcelo-Giufrida',
    },
    {
      nome: 'Otávio Yazbek',
      cargo: 'Conselheiro',
      descricao: 'membro independente',
      imagem: 'Otavio-Yazbek',
    },
    {
      nome: 'Renato Oliva',
      cargo: 'Conselheiro',
      descricao: 'Santander',
      imagem: 'Renato-Oliva',
    },
    {
      nome: 'Robert van Dijk',
      cargo: 'Conselheiro',
      descricao: 'Hieron',
      imagem: 'Robert-van-Dijk',
    },
    {
      nome: 'Saša Markus',
      cargo: 'Conselheiro',
      descricao: 'membro independente',
      imagem: 'Sasa-Markus',
    },
  ],
};

export { conselho_etica };
